var Capabilities = (function () {
    function Capabilities() {
    }
    Object.defineProperty(Capabilities, "playerType", {
        get: function () {
            return "StandAlone"; //"Plugin"
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Capabilities, "touchscreenType", {
        get: function () {
            return "none"; //"Plugin"
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Capabilities, "screenDPI", {
        get: function () {
            return 0; //"Plugin"
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Capabilities, "screenResolutionX", {
        get: function () {
            return screen.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Capabilities, "screenResolutionY", {
        get: function () {
            return screen.height;
        },
        enumerable: true,
        configurable: true
    });
    return Capabilities;
}());
export { Capabilities };
